import { OrderDeliveryInfo, OrderHeader } from '@epicuro-next/data/order-book';
import { IOrderItemWithProductInfo } from '@epicuro-next/models/order-book';
import { isNonNullish } from '@epicuro-next/utilities';
import { Maybe } from 'graphql/jsutils/Maybe';

export function mergeOrderItemsWithUrls(
  orderItems: IOrderItemWithProductInfo[],
  orderHeader: OrderHeader,
  useDeliveryNoteUrl: boolean,
): IOrderItemWithProductInfo[] {
  return orderItems.map((orderItem: IOrderItemWithProductInfo) => ({
    ...orderItem,
    invoices: orderItem.invoiceNumbers
      ?.map((invoiceNumber) =>
        orderHeader?.invoices.filter(
          (invoice) => invoice.number === invoiceNumber,
        ),
      )
      .flat(1)
      .filter(isNonNullish),
    deliveries: getDeliveries(
      orderItem.deliveryNumbers,
      orderHeader?.deliveries,
      useDeliveryNoteUrl,
    ),
    trackings: getDeliveries(
      orderItem.deliveryNumbers,
      orderHeader?.deliveries,
      useDeliveryNoteUrl,
    )
      .flatMap((delivery) => delivery.deliveryTracking)
      .filter(isNonNullish),
  }));
}

function getDeliveries(
  deliveryNumbers: Maybe<string>[] | null | undefined,
  deliveries: OrderDeliveryInfo[] = [],
  useDeliveryNoteUrl: boolean = false,
): OrderDeliveryInfo[] {
  return (deliveryNumbers ?? [])
    ?.map((deliveryNumber) =>
      deliveries.filter(
        (delivery) => delivery.deliveryNumber === deliveryNumber,
      ),
    )
    .flat(1)
    .filter(isNonNullish)
    .map((item) => {
      if (!useDeliveryNoteUrl) {
        return {
          ...item,
          deliveryNoteUrl: undefined,
        };
      }

      return item;
    });
}
